import { Injectable } from '@angular/core';
import { getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, getDoc, doc } from 'firebase/firestore';
import { Subject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class AdminService {
  isAdmin: boolean = false;

  async checkIfAdmin(email: string) {

    const firestoreDB = getFirestore(getApp());
    const username = email.split("@")[0];
    const docRef = doc(firestoreDB, "admins", username);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      console.log("hello it worked for admins");

      //this email is in our admin collection.
      this.isAdmin = true;
    }
    else {
    }
  }

  getAdminStatus() {
    return this.isAdmin;
  }
}

